// feature 025 (US2): única copia del criterio de tamaño de página (FR-015).
export const PAGE_SIZE = 20;

export const PAGE_SIZE_OPTIONS = [10, 20, 50, 100];

export const DEFAULT_SORTING_COLUMN = { sortingColumn: "timestamp" };

export const DEFAULT_PREFERENCES = {
  pageSize: PAGE_SIZE,
  wrapLines: true,
  visibleContent: ["timestamp", "jobName", "supervisor", "agent", "actions"]
};

/**
 * Valida las preferencias leídas de localStorage: completa con `defaults` lo que falte
 * y descarta un `pageSize` que no esté en PAGE_SIZE_OPTIONS (ej. uno viejo o editado a mano).
 */
export function sanitizePreferences(raw, defaults = DEFAULT_PREFERENCES) {
  if (!raw || typeof raw !== "object" || Array.isArray(raw)) {
    return { ...defaults };
  }
  const pageSize = PAGE_SIZE_OPTIONS.includes(raw.pageSize) ? raw.pageSize : defaults.pageSize;
  return { ...defaults, ...raw, pageSize };
}

export const ALL_SUPERVISORS_OPTION = "__ALL__";

